<template id="control-product">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Control Product</li>
      </ol>
    </nav>
    <div class="listControlProduct">
      <div class="row">
        <div class="col-md-4">
          <h3>Control Product</h3>
        </div>
        <div class="col-md-4">
        </div>
        <div class="col-md-4">
          <button type="button" class="btn btn-primary mr-2" @click="showAddCategoryModal">
            + เพิ่มหมวดใหม่
          </button>
          <button type="button" class="btn btn-secondary float-right" @click="refreshItems">
            รีเฟรชข้อมูล
          </button>
        </div>
      </div>
      <general-pagination
        v-if="paginate_data._infos._total"
        :paginate_data="paginate_data"
        @paginateItemClick="setCurrentPageAndSearch"
      ></general-pagination>
      <general-loading v-if="showLoading"></general-loading>
      <div class="row">
        <div class="col-md-12">
          <div
            class="card card-body mt-1"
            v-for="item in displayItems"
            :key="'cp-' + item.section_name"
          >
            <div class="row align-items-center">

              <div class="col-md-8">
                <h4 class="text text-primary mb-1">
                  {{ item.section_name }}
                </h4>

                <div v-if="item.product_list && item.product_list.length" class="mt-1">
                  <span
                    class="badge badge-secondary mr-1"
                    v-for="(productList, idx) in item.product_list"
                    :key="item.section_name + '-product-list-' + idx"
                  >
                    {{ productList }}
                  </span>
                </div>
              </div>
              <div class="col-md-4 text-right">
          <button
            type="button"
            class="btn btn-light"
            @click="showEditSkuModal(item.section_name)"
          >
            แก้ไข
          </button>

          <button
            type="button"
            class="btn btn-danger"
            data-toggle="modal"
            data-target="#ConfirmDeleteModal"
            @click="setForDeleteItemId(item.section_name)"
          >
            ลบ
          </button>
        </div>
            </div>
          </div>
        </div>
      </div>
      <general-pagination
        v-if="paginate_data._infos._total"
        :paginate_data="paginate_data"
        @paginateItemClick="setCurrentPageAndSearch"
      ></general-pagination>
      <div v-if="recordNotFound" class="alert alert-warning" role="alert">
        ไม่พบข้อมูล
      </div>
    </div>
    <div class="modal fade" id="AddCategoryModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">เพิ่มหมวดใหม่</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <label for="newProductListInput">Product List Group</label>  
            <select class="form-control mb-2" v-model="sectionName">
              <option value="" disabled>-- โปรดเลือก Product List Group --</option>
              <option v-for="product_list_name in product_list_name" :key="product_list_name" :value="product_list_name">{{ product_list_name }}</option>
            </select>
            <label for="newProductListInput">Category Name</label>  
            <select class="form-control" v-model="newProductListName">
              <option value="" disabled>-- โปรดเลือก Category Name --</option>
              <option
                v-for="val in product_list_name_value[sectionName]"
                :key="val"
                :value="val"
              >
                {{ val }}
              </option>
            </select>
            <div class="form-group">
              <label for="newPerPageInput">จำนวนสินค้าต่อหน้า (per_page)</label>
              <input
                id="newPerPageInput"
                type="text"
                inputmode="numeric"
                :class="['form-control', { 'is-invalid': perPageError }]"
                v-model="per_page_product"
                placeholder="ว่าง = ใช้ค่าจากหน้าเว็บ"
                @input="perPageError = ''"
              >
              <small class="form-text text-muted">
                1–500 · ค่าว่าง = ไม่ override ใช้จำนวนที่หน้าเว็บส่งมา (ปักหมุด SKU ทุกตัวในรายการ)
              </small>
              <div v-if="perPageError" class="invalid-feedback d-block">{{ perPageError }}</div>
            </div>
            <label for="newProductSkuTextarea">SKU (คั่นด้วย , หรือเว้นวรรค)</label>
            <textarea
              id="newProductSkuTextarea"
              class="form-control"
              rows="4"
              v-model="newProductSkuText"
              placeholder="H036, H035, B611"
            ></textarea>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">ยกเลิก</button>
            <button type="button" class="btn btn-primary" @click="saveNewCategory">บันทึกหมวดใหม่</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="EditSkuModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit SKU</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              v-for="(item, index) in editItems"
              :key="item.id || 'new-' + index"
              :class="['mb-4', 'pb-3', { 'border-bottom': index < editItems.length - 1 }]"
            >
              <div v-if="item.isNew" class="form-group">
                <label>Product List Group</label>
                <select class="form-control mb-2" v-model="item.section_name">
                  <option value="" disabled>-- โปรดเลือก Product List Group --</option>
                  <option v-for="product_list_name in product_list_name" :key="product_list_name" :value="product_list_name">{{ product_list_name }}</option>
                </select>
              </div>
              <div v-if="item.isNew" class="form-group">
                <label>Category Name</label>
                <select class="form-control mb-2" v-model="item.product_list">
                  <option value="" disabled>-- โปรดเลือก Category Name --</option>
                 <option
                    v-for="val in product_list_name_value[item.section_name]"
                    :key="val"
                    :value="val"
                  >
                    {{ val }}
                  </option>
                </select>
              </div>
              <p v-else class="mb-2 font-weight-bold">{{ item.product_list }}</p>
              <label>SKU (คั่นด้วย , หรือเว้นวรรค)</label>
              <textarea
                class="form-control w-100 mb-2"
                rows="4"
                v-model="item.skuText"
                placeholder="H036, H035, B611"
              ></textarea>
              <div class="form-group">
                <label>จำนวนสินค้าต่อหน้า (per_page)</label>
                <input
                  type="text"
                  inputmode="numeric"
                  :class="['form-control', 'mb-1', { 'is-invalid': item.perPageError }]"
                  v-model="item.per_page"
                  placeholder="ว่าง = ใช้ค่าจากหน้าเว็บ"
                  @input="$set(item, 'perPageError', '')"
                />
                <small class="form-text text-muted">
                  1–500 · ลบให้ว่างแล้วบันทึก = ล้างค่า กลับไปใช้จำนวนที่หน้าเว็บส่งมา
                </small>
                <div v-if="item.perPageError" class="invalid-feedback d-block">{{ item.perPageError }}</div>
              </div>
              <button
                type="button"
                class="btn btn-sm btn-outline-danger"
                @click="removeEditItem(item, index)"
              >
                ลบ
              </button>
            </div>
            <!-- <button type="button" class="btn btn-secondary mt-2 btn-block" @click="addNewItem">
              + เพิ่มรายการใหม่
            </button> -->
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">ยกเลิก</button>
            <button type="button" class="btn btn-primary" @click="saveEditSku">บันทึกการแก้ไข</button>
          </div>
        </div>
      </div>
    </div>
    <general-delete-modal @ConFirmDeleteClick="performDeleteItem"></general-delete-modal>
    <button
      style="display: none"
      type="button"
      class="btn btn-primary"
      data-toggle="modal"
      data-target="#AlertModal"
      ref="decoyAlertModalClick"
    >
      test
    </button>
    <general-alert-modal :alertMessage="alertMessage"></general-alert-modal>
  </div>
</template>

<script>
import paginate from "../_layouts/pagination.vue";
import { defaultPerPageFor, parsePerPageInput } from "./perPage.mjs";

export default {
  components: {
    paginate,
  },
  computed: {
    displayItems() {
      return this.items;
    },
  },
  watch: {
    sectionName(val) {
      if (val !== "home") {
        // auto-set product_list = section name (ไม่ต้องเลือกเอง)
        this.newProductListName = val;
      } else {
        // home → ให้เลือก product_list เอง
        this.newProductListName = "";
      }
      // เติมค่าเริ่มต้นจำนวนสินค้าต่อหน้าตาม section เฉพาะเมื่อช่องยังว่าง (แอดมินแก้เองได้)
      if (!String(this.per_page_product || "").trim()) {
        this.per_page_product = defaultPerPageFor(val);
      }
      this.perPageError = "";
    },
  },
  data() {
    return {
      product_list_name: [
      "Home Carousel",
      "Category",
      "Location",
      ],
      product_list_name_value: {
        "Home Carousel": ["พวงหรีดมาแรง", "พวงหรีดดอกไม้สด","พวงหรีดพัดลม","พวงหรีดของใช้","พวงหรีดต้นไม้"],
        "Category": [
          "พวงหรีดดอกไม้สดทั้งหมด",
          "โปรโมชั่น",
          "พวงหรีดอื่นๆทั้งหมด",
          "พวงหรีดพัดลม",
          "พวงหรีดพัดลม 16 นิ้ว",
          "พวงหรีดพัดลม 18 นิ้ว",
          "พวงหรีดพัดลม 20 นิ้ว",
          "พวงหรีดพัดลม 22 นิ้ว",
          "พวงหรีดของใช้",
          "พวงหรีดผ้า",
          "พวงหรีดผ้าแพร",
          "พวงหรีดผ้านวม",
          "พวงหรีดช้อน",
          "พวงหรีดดอกไม้ประดิษฐ์",
          "พวงหรีดต้นไม้",
        ],
        "Location": ["พวงหรีดใกล้วัดพวงหรีดแนะนำ","พวงหรีดใกล้วัดกรุงเทพมหานคร","พวงหรีดใกล้วัดนนทบุรี","พวงหรีดใกล้วัดสมุทรปราการ"]
      },
      items: [],
      paginate_data: {
        _infos: {},
        _base_item_list_url: "",
      },
      alertMessage: {
        titleClassName: "warning",
        titleMessage: "แจ้งเตือน!!",
        bodyClassName: "warning",
        bodyMessage: "This is alert",
      },
      recordNotFound: false,
      showLoading: true,
      base_item_url: "/control-product",
      currentPage: 1,
      item_id_for_delete: "",
      selectedTagIds: [],
      editSkuText: "",
      sectionName: "",
      newProductListName: "",
      newProductSkuText: "",
      editItems:[],
      sectionName: "",
      per_page_product: "",
      perPageError: "",
    };
  },
  created() {
    this.searchItems();
  },
  methods: {
    setCurrentPageAndSearch(page) {
      this.currentPage = page;
      this.searchItems();
    },
    refreshItems() {
      this.searchItems();
    },
    searchItems() {
      let url = this.base_item_url + "/list";
      if (this.selectedTagIds.length) {
        url = url + "&tag_ids=" + this.selectedTagIds.join(",");
      }
      this.fetchItems(url);
    },
    fetchItems(url) {
      this.showLoading = true;
      this.items = [];

      url = url || this.base_item_url + "/list";

      axios
        .get(url)
        .then((response) => {
          const data = response.data;
          const products = data.products || data;
          const list = products.items || products.data || products || [];

          const grouped = {};

          const allProductLists = new Set();

          list.forEach((item) => {
            const section = item.section_name || "unknown";

            if (!grouped[section]) {
              grouped[section] = {
                section_name: section,
                sku: [],
                product_list: []
              };
            }

            if (Array.isArray(item.sku)) {
              grouped[section].sku.push(...item.sku);
            }

            if (item.product_list) {
              grouped[section].product_list.push(item.product_list);
              allProductLists.add(item.product_list);
            }
          });

          this.items = Object.values(grouped).map((group) => ({
            ...group,
            product_list: [...new Set(group.product_list)]
          }));
          this.sectionOptions = Object.keys(grouped);
          this.productListOptions = Array.from(allProductLists);

          this.recordNotFound = list.length === 0;
          this.showLoading = false;
        })
        .catch((errors) => {
          console.log(errors);
          this.recordNotFound = true;
          this.showLoading = false;
        });
    },
    showEditSkuModal(sectionName) {
       axios.get(this.base_item_url + "/" + sectionName)
        .then((response) => {

          const data = response.data
          const list = data.data || []

          this.editItems = list.map(item => ({
            ...item,
            skuText: item.sku.join(","),
            // prefill จาก API เท่านั้น (NULL → ช่องว่าง) ไม่เติม default เพื่อไม่ให้กด "บันทึก" เฉย ๆ แล้วพฤติกรรมเว็บเปลี่ยน
            per_page: item.per_page == null ? "" : String(item.per_page),
            perPageError: "",
          }));

          $("#EditSkuModal").modal("show")

        })
        .catch((err)=>{
          console.log(err)
        })
    },
    parseSkuText(text) {
      const skuText = (text || "").trim();
      return skuText
        .split(/[\s,]+/)
        .map((s) => s.trim())
        .filter(Boolean);
    },
    saveEditSku() {
      const section_name = this.editItems[0]?.section_name;
      if (!section_name) return;

      const updateUrl = this.base_item_url + "/" + section_name + "/update";
      const createUrl = this.base_item_url;

      const updateItems = [];
      const newItems = [];

      try {
      this.editItems.forEach(item => {
        const skuArr = item.skuText.split(/[\s,]+/).filter(Boolean);

        const parsed = parsePerPageInput(item.per_page, { emptyAs: "clear" });
        if (parsed.error) {
          this.$set(item, "perPageError", parsed.error);
          throw new Error("validation error");
        }

        const data = {
          product_list: item.product_list,
          sku: skuArr,
          per_page: parsed.value, // "" = ล้างค่า (ผ่าน form_params ถึง ERP แล้วถูกแปลงเป็น null)
        };

        if (item.isNew) {

          // validation
          if (!item.product_list || skuArr.length === 0) {
            alert("กรุณากรอก product_list และ sku สำหรับรายการใหม่");
            throw new Error("validation error");
          }

          newItems.push({
            ...data,
            section_name: section_name
          });

        } else {
          updateItems.push(data);
        }
      });
      } catch (e) {
        if (e && e.message === "validation error") return; // error แสดงใต้ช่องแล้ว ไม่ยิง request
        throw e;
      }

      const requests = [];

      if (updateItems.length > 0) {
        requests.push(axios.post(updateUrl, updateItems));
      }

     
      if (newItems.length > 0) {
        requests.push(axios.post(createUrl, newItems));
      }

      Promise.all(requests)
        .then(() => {
          $("#EditSkuModal").modal("hide");
          this.searchItems();
        })
        .catch((errors) => {
          if (
            errors.response &&
            errors.response.data &&
            errors.response.data._infos &&
            errors.response.data._infos.result
          ) {
            this.alertMessage.bodyMessage = errors.response.data._infos.result;
            this.$refs.decoyAlertModalClick.click();
          } else {
            alert(
              "ไม่สามารถบันทึกได้ " +
                (errors.response && errors.response.data
                  ? JSON.stringify(errors.response.data)
                  : "")
            );
          }
        });
    },
    addNewItem() {
      const sectionName = this.editItems[0]?.section_name || "";
      this.editItems.push({
        section_name: sectionName,
        product_list: "",
        skuText: "",
        isNew: true,
      });
    },
    removeEditItem(item, index) {
      if (item.isNew) {
        this.editItems.splice(index, 1);
      } else if (item.product_list) {
        this.deleteItem(item.product_list, index);
      }
    },
    deleteItem(productList, index) {
      axios.post(this.base_item_url + "/" + productList + "/deleteByProductList")
        .then(() => {
          if (typeof index === "number") {
            this.editItems.splice(index, 1);
          }
          this.searchItems();
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    setForDeleteItemId(sectionName) {
      this.item_id_for_delete = sectionName;
    },
    showAddCategoryModal() {
      this.sectionName = "";
      this.newProductListName = "";
      this.newProductSkuText = "";
      this.per_page_product = "";
      this.perPageError = "";
      $("#AddCategoryModal").modal("show");
    },
    saveNewCategory() {
      const productListName = (this.newProductListName || "").trim();
      if (!productListName) {
        alert("กรุณากรอกชื่อหมวด");
        return;
      }
      const parsed = parsePerPageInput(this.per_page_product, { emptyAs: "omit" });
      if (parsed.error) {
        this.perPageError = parsed.error;
        return;
      }
      const skuList = this.parseSkuText(this.newProductSkuText);
      const newItem = {
        product_list: productListName,
        sku: skuList,
        section_name: this.sectionName,
      };
      if (parsed.value !== undefined) {
        newItem.per_page = parsed.value; // ว่าง = ไม่ส่ง field → ERP บันทึก NULL
      }
      axios
        .post(this.base_item_url, [newItem])
        .then(() => {
          $("#AddCategoryModal").modal("hide");
          this.searchItems();
        })
        .catch((errors) => {
          if (errors.response && errors.response.data && errors.response.data._infos && errors.response.data._infos.result) {
            this.alertMessage.bodyMessage = errors.response.data._infos.result;
            this.$refs.decoyAlertModalClick.click();
          } else {
            alert("ไม่สามารถบันทึกได้ " + (errors.response && errors.response.data ? JSON.stringify(errors.response.data) : ""));
          }
        });
    },
    performDeleteItem() {
      axios
        .post(this.base_item_url + "/" + this.item_id_for_delete + "/delete")
        .then((response) => {
          this.searchItems();
        })
        .catch((errors) => {
          if (errors.response && errors.response.data && errors.response.data._infos && errors.response.data._infos.result) {
            this.alertMessage.bodyMessage = errors.response.data._infos.result;
            this.$refs.decoyAlertModalClick.click();
          } else {
            alert("ไม่สามารถลบได้ " + (errors.response && errors.response.data ? JSON.stringify(errors.response.data) : ""));
          }
        });
    },
  },
};
</script>
